import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Overlay = styled(Box)({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  cursor: 'pointer',
  '& p': {
    color: 'white',
    textDecoration: 'underline',
  },
});
